import React from 'react';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { StandoutTile } from 'web-ui-components/lib/layout/content';
import { BulletList } from 'web-ui-components/lib/typography/lists';
import PropTypes from '../../types';
import { Content } from '../../infrastructure/content';

const DeferredPage = ({ bankId, username }) => (
  <Content>
    {({
      deferredPageTitle = '',
      deferredContent1,
      deferredContent3,
      deferredContent4,
      deferredContent5,
      deferredContent6,
      deferredContent7,
      deferredContent8,
      closeWindow
    }) => (
      <StandardBody>
        <PageHeading>{deferredPageTitle}</PageHeading>
        <p>{deferredContent1}</p>
        <StandoutTile.Remember>
          <p>{deferredContent3}</p>
          <BulletList
            items={[deferredContent4, deferredContent5, deferredContent6, deferredContent7]}
          />
          <p>
            <b>
              {deferredContent8} {username}
            </b>
          </p>
        </StandoutTile.Remember>
        <p>
          <strong>{closeWindow}</strong>
        </p>
      </StandardBody>
    )}
  </Content>
);

DeferredPage.propTypes = {
  bankId: PropTypes.bankId.isRequired
};

export default DeferredPage;
